import { render, staticRenderFns } from "./GameKeyboard.vue?vue&type=template&id=7a1cef1c&"
import script from "./GameKeyboard.vue?vue&type=script&lang=js&"
export * from "./GameKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./GameKeyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports